import React from "react";
import pure from "./higher-order/pure";

export default pure(function LightBoxFooter({ children }) {
  return (
    <div className="lightbox_footer">
      {children}
    </div>
  );
});
